<template>
  <v-container fluid class="scrollable-content">
    <v-row no-gutters>
      <v-col cols="12" md="4" offset-md="8">
        <v-text-field
          v-model="search"
          placeholder="Filtra per Località"
          class="mr-md-4"
          prepend-icon="mdi-map-search"
        ></v-text-field>
      </v-col>
    </v-row>
    <v-expansion-panels :variant="isMobile ? 'default' : 'popout'">
      <v-expansion-panel readonly>
        <v-expansion-panel-title expand-icon="" class="hidden-sm-and-down">
          <v-row no-gutters>
            <v-col cols="4"><strong>Nome</strong></v-col>
            <v-col cols="4"><strong>Indirizzo</strong></v-col>
            <v-col cols="3" class="hidden-sm-and-down"
              ><strong>Località (Provincia)</strong></v-col
            >
            <v-col cols="1" class="hidden-sm-and-down"
              ><strong>CAP</strong></v-col
            >
          </v-row>
        </v-expansion-panel-title>
      </v-expansion-panel>
      <v-expansion-panel v-for="(e, i) in filialiInProvincia" :key="i">
        <v-expansion-panel-title v-slot="{ open }">
          <v-row no-gutters>
            <v-fade-transition leave-absolute>
              <v-col cols="12" md="4" v-if="open">
                <span key="0">
                  <strong class="ml-4">{{ e.Nome }} </strong></span
                >
              </v-col>
              <v-col v-else cols="12" md="4">
                <span key="1"> {{ e.Nome }} </span>
              </v-col>
            </v-fade-transition>
            <v-col cols="12" md="4" class="text--secondary">
              <v-fade-transition leave-absolute>
                <span v-if="!open" key="0">{{ IndirizzoShort(e) }} </span>
              </v-fade-transition>
            </v-col>
            <v-col md="3" class="text--secondary hidden-sm-and-down">
              <v-fade-transition leave-absolute>
                <span v-if="!open" key="0">
                  {{ e.Citta }} ({{ e.Provincia }})
                </span>
              </v-fade-transition>
            </v-col>
            <v-col md="1" class="text--secondary hidden-sm-and-down">
              <v-fade-transition leave-absolute>
                <span v-if="!open" key="0"> {{ e.CAP }} </span>
              </v-fade-transition>
            </v-col>
          </v-row>
        </v-expansion-panel-title>
        <v-expansion-panel-text>
          <v-row no-gutters>
            <v-col cols="12" md="4">
              <v-row no-gutters>
                <v-col cols="12">
                  <strong>Indirizzo:</strong> {{ e.Indirizzo }}
                </v-col>
                <v-col cols="12">
                  <strong>Località:</strong> {{ e.Citta }} ({{
                    e.Provincia
                  }})</v-col
                >
                <v-col cols="12"><strong>CAP:</strong> {{ e.CAP }} </v-col>
              </v-row>
            </v-col>
            <v-col cols="12" md="8" class="mt-2 my-md-0">
              <v-row>
                <v-col cols="12" class="hidden-sm-and-down"
                  ><strong>Servizi Disponibili</strong></v-col
                >
              </v-row>
              <v-row>
                <v-col cols="12">
                  <v-chip
                    v-for="(s, j) in e.Servizi"
                    :key="j"
                    class="mr-1"
                    :model-value="true"
                  >
                    {{ s }}
                  </v-chip>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn variant="text" color="#102a63" @click="select(i, e)"
              >Prenota</v-btn
            >
          </v-card-actions>
        </v-expansion-panel-text>
      </v-expansion-panel>
    </v-expansion-panels>
  </v-container>
</template>

<script setup lang="ts">
import { computed, onMounted, ref } from "vue";
import { Filiale } from "@/models/filiale";
import { IsMobile } from "@/utils/Mobile";
import { useBookingStore } from "@/features/booking/store";

const props = defineProps<{
  provincia?: string;
}>();

const emit = defineEmits<{
  select: [payload: { filiale: Filiale; pos: number }];
}>();

const bookingStore = useBookingStore();

onMounted(() => {
  window.addEventListener("resize", () => {
    const c = document.getElementById("content") as HTMLElement;
    c.style.height = `${window.innerHeight - 400}px`;
  });
});

const search = ref("");

const filialiInProvincia = computed((): Array<Filiale> => {
  const collator = new Intl.Collator(undefined, {
    numeric: true,
    sensitivity: "base",
  });

  return bookingStore.Filiali.filter(
    (f: Filiale) =>
      f.Provincia == props.provincia &&
      f.Citta.toLowerCase().includes(search.value.toLowerCase()),
  )
    .map((f: Filiale) => {
      f.Nome = f.Nome.replace(" Sede", " 0");
      return f;
    })
    .sort(
      (a: Filiale, b: Filiale) =>
        a.Citta.localeCompare(b.Citta) || collator.compare(a.Nome, b.Nome),
    )
    .map((f: Filiale) => {
      f.Nome = f.Nome.replace(" 0", " Sede");
      return f;
    });
});

function select(i: number, filiale: Filiale): void {
  emit("select", { filiale: filiale, pos: i + 1 });
}

const isMobile = computed((): boolean => IsMobile());

function IndirizzoShort(f: Filiale): string {
  if (!isMobile.value) {
    return f.Indirizzo;
  }

  return `${f.Indirizzo} (${f.Citta})`;
}
</script>

<style scoped>
.scrollable-content {
  height: calc(100vh - 180px);
  overflow-y: auto;
}
</style>
